import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgAlertCircleOutline = function SvgAlertCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3636 3.25763L21.8476 15.8443C22.9375 17.6774 21.6166 19.9998 19.4839 19.9998H4.51593C2.38324 19.9998 1.06227 17.6774 2.1522 15.8443L9.63617 3.25764C10.7021 1.46492 13.2977 1.46492 14.3636 3.25763ZM13.0743 4.02422C12.5898 3.20937 11.41 3.20937 10.9255 4.02423L3.44151 16.6109C2.94607 17.4442 3.54656 18.4998 4.51593 18.4998H19.4839C20.4532 18.4998 21.0537 17.4442 20.5583 16.6109L13.0743 4.02422ZM11.9999 7.99977C12.4141 7.99977 12.7499 8.33555 12.7499 8.74977V12.7498C12.7499 13.164 12.4141 13.4998 11.9999 13.4998C11.5857 13.4998 11.2499 13.164 11.2499 12.7498V8.74977C11.2499 8.33555 11.5857 7.99977 11.9999 7.99977ZM10.9999 15.4998C10.9999 14.9475 11.4476 14.4998 11.9999 14.4998C12.5519 14.4998 12.9999 14.9473 12.9999 15.4998C12.9999 16.052 12.5521 16.4998 11.9999 16.4998C11.4474 16.4998 10.9999 16.0518 10.9999 15.4998Z"
  })));
};

export { SvgAlertCircleOutline as ReactComponent };
//# sourceMappingURL=alert-circle-outline.svg.js.map
